// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"721":"5d31f383","1124":"20378468","1637":"5d31f383","4827":"253558d6","6668":"730875e2","8112":"50c09267"}[chunkId] + ".chunk.css";
};